import React from 'react';

export function RubleSign() {
  return <span>₽</span>
}
